import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { HostBackend } from '../../../Routes/HostBackend.js';
import { PostHeaders } from '../../../Components/Admin/Functions/FetchHeaders.js';
import { Fields } from './Fields.js';
import { MsgBackend } from '../Document/MsgBackend.js';

export const FormInsert = () => {
    const { entity } = useParams();
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [msg, setMsg] = useState('');

    const handleSubmitInsert = async (ev) => {
        ev.preventDefault();
        try {
            const inputs = document.getElementById("form-insert").elements;
            const params = new URLSearchParams();
            for (let input of inputs) {
                if (input.name && input.value && input.name !== undefined && input.value !== undefined) {
                    params.append(input.name, input.value.toString());
                }
            }
            const formEntries = Object.fromEntries(params.entries());
            const resp = await fetch(`${backend}/admin/insert/${entity}`, PostHeaders(token, formEntries)).catch((e) => {
                setMsg({ css: 'bkg-error', msg: e.msg });
            });
            if (resp && resp.ok) {
                setMsg({ css: 'bkg-success', msg: resp.msg })
                setTimeout(window.location = `/admin/entity/collection/${entity}`, 3000);
            }
        } catch (e) {
            setMsg({ css: 'bkg-error', msg: e.message });
        }
    }
    return (
        <div className="admin-form">
            <MsgBackend msg={msg} />
            <form className="form" id="form-insert" onSubmit={handleSubmitInsert}>
                <fieldset>
                    <legend>{`INSERT: ${entity}`}</legend>
                    <Fields entity={entity} />
                    <input className="button" type="submit" defaultValue="Insert" />
                </fieldset>
            </form>
            <a className="back" href={`/admin/entity/collection/${entity}`} alt="back" title="back">
                <i className="fa fa-reply"></i>
            </a>
        </div>
    )
}